import { connect } from 'react-redux'
import { Component } from "macguffin"
import { findTexture, Stage } from 'mc_pixi-fiber'
import { Sprite } from 'react-pixi-fiber'
import { Loader } from "pixi.js"
const { resources } = Loader.shared

import { setReelStopped, setReelStopping, setCometFlypast } from "game/redux/actions"

import Reel from "./Reel"
import { calculateAnticipation, calculateSpinDurations, getDefaultAnticipation, getDefaultSpinDurations } from "./anticipation"

import GameMode from "game/modes"
import GameModeGroup from "game/modes/GameModeGroup"

const { assign } = Object
const { floor } = Math

const ANIMATION_TIMEOUT = 1000

const REEL_BACKGROUND_SCALE = 0.9

const anticipationGroup = new GameModeGroup([GameMode.RESPIN, GameMode.COMET_WILDS])

export function getReplacements(symbolReplacements, reels) {
    return symbolReplacements && reels.map((reel, index) => {
        return symbolReplacements.filter((replacement) => {
            return (replacement.x - 1) === index
        })
    })
}

@connect(state => ({
    isSpinning: state.game.isSpinning,
    currentSpinData: state.game.currentSpinData,
    reelsConfig: state.game.reelsConfig,
    reelStoppedIndex: state.game.reelStoppedIndex,
    currentGameMode: state.game.currentGameMode,
    currentWinData: state.game.currentWinData,
    currentWinIteration: state.game.currentWinIteration,
    skipfeature: state.base.skipfeature,
    globalPaused: state.base.paused
}), {
    setReelStopped,
    setReelStopping,
    setCometFlypast
})
export default class Reels extends Component {

    constructor() {
        super()

        const reelBackgroundTexture = findTexture("reel/Reel_stripe")
        const reelsBackgroundTexture = findTexture("reel/Reel_bg")

        const prepare = [
            resources["badge"].texture.baseTexture,
            resources["reel-atlas"].spritesheet.baseTexture,
            resources["meteor_atlas_page_meteor_spine.png"].texture.baseTexture
        ]

        this.state = {
            prepare,
            reelBackgroundTexture,
            reelsBackgroundTexture,
            defaultDurations: getDefaultSpinDurations()
        }
    }

    componentWillMount() {
        const { props } = this
        const { reelsConfig = {}, currentSpinData = {} } = props
        const { symbolReplacements, grid } = currentSpinData
        const { grids } = reelsConfig
        const { reels } = grids[grid] || grids.baseReels
        const replacements = getReplacements(symbolReplacements, reels)
      
        reels && this.setState({ reels, replacements })
    }

    componentWillReceiveProps(nextProps) {
        const currentProps = this.props

        const {
            reelsConfig = {},
            currentSpinData = {},
            reelStoppedIndex,
            isSpinning,
            skipfeature
        } = nextProps


        const newState = {}

        if (reelStoppedIndex !== currentProps.reelStoppedIndex && reelStoppedIndex === -1) {
            assign(newState, { isStopping: undefined, skip: undefined })
        }

        if (currentSpinData !== currentProps.currentSpinData) {
            if(!currentSpinData.grid) { return }
            const { symbolReplacements, grid } = currentSpinData
            const { grids } = reelsConfig
            const { reels } = grids[grid]

            const replacements = getReplacements(symbolReplacements, reels)

            const { currentGameMode } = nextProps

            const anticipation = !skipfeature ? calculateAnticipation(nextProps) : getDefaultAnticipation()
            const spinDurations = !skipfeature ? calculateSpinDurations(nextProps) : getDefaultSpinDurations()

            assign(newState, {
                reels,
                anticipation,
                spinDurations,
                replacements,
                isStopping: true
            })
        }

        if (isSpinning !== currentProps.isSpinning) {
            const { endStickyWilds } = currentSpinData
            const hasRespinAnticipation = (endStickyWilds && endStickyWilds.length)

            const animationsPlaying = true
            assign(newState, { isSpinning, hasRespinAnticipation, animationsPlaying })
        }

        if (skipfeature && skipfeature !== currentProps.skipfeature) {
            assign(newState, { skip: skipfeature })
        }

        this.setState(newState)
    }

    render() {
        const { props, state = {} } = this
        if(!props.currentSpinData) { return null }

        const {
            currentGameMode,
            currentSpinData: { symbols, stops },
            currentWinData,
            currentWinIteration,
            height,
            left,
            reelStoppedIndex,
            resolution,
            setReelStopped,
            setReelStopping,
            top,
            visibility,
            width,
            setCometFlypast,
            globalPaused
        } = props

        const {
            reels,
            anticipation,
            defaultDurations,
            spinDurations,
            isSpinning,
            isStopping,
            skip,
            prepare,
            reelsBackgroundTexture,
            reelBackgroundTexture,
            replacements,
            hasRespinAnticipation
        } = state

        const reelWidth = floor(width * 0.2)

        const style = {
            top: `${top}px`,
            left: `${left}px`,
            width: `${width}px`,
            height: `${height}px`,
            visibility
        }

        const classNames = [ "reelsContainer" ]

        if (hasRespinAnticipation) {
            classNames.push("reelsContainerAnticipation")
        }

        return <div key="reelsContainer" className={classNames.join(" ")} style={style}>
            <Stage
                key = "reelsCanvas"
                name = "reelsCanvas"
                style = {{ width, height }}
                {...{
                    resolution: resolution,
                    width: width,
                    height: height,
                    paused: globalPaused,
                    options: {
                        prepare,
                        transparent: true,
                        backgroundColor: 0x000000,
                        antialias: true
                    }
                }}
                >
                    {
                        reels && reels.map((reel, index) => {
                            return <Sprite
                                key = {`ReelBackground${index}`}
                                texture = {reelBackgroundTexture}
                                width = {reelWidth * REEL_BACKGROUND_SCALE}
                                height = {height}
                                anchor = {0.5}
                                x = { (index * reelWidth) + (reelWidth * 0.5) }
                                y = { height * 0.5 }
                            />
                        })
                    }

                    <Sprite texture={reelsBackgroundTexture} width={width} height={height} x={0} y={0} />

                    {
                        reels && reels.map((reel, index) => {
                            const key = `Reel${index}`
                            return <Reel
                                key = {key}
                                index = {index}
                                width = {reelWidth}
                                height = {height}
                                resolution = {resolution}
                                reel = {reel}
                                stop = {stops[index]}
                                symbols = {symbols[index]}
                                replacements = {replacements && replacements[index]}
                                isSpinning = {isSpinning}
                                isStopping = {isStopping}
                                isSkipping = {skip}
                                anticipationSymbols = {anticipation && anticipation[index]}
                                defaultSpinDuration = {defaultDurations[index]}
                                spinDuration = {spinDurations && spinDurations[index]}
                                onComplete = {setReelStopped}
                                setReelStopping = {setReelStopping}
                                currentGameMode = {currentGameMode}
                                currentWinData = {currentWinData}
                                currentWinIteration = {currentWinIteration}
                                setCometFlypast = {setCometFlypast}
                                reelStoppedIndex = {reelStoppedIndex}
                            />
                        })
                    }
            </Stage>
        </div>
    }
}
